<template lang="html">
	<div :class='locked ? "list-of-portfolio locked" : "list-of-portfolio"'>
		<!-- <pre>{{data}}</pre> -->

		<template v-if='!items.length'>
			{{ data.nothing_to_show }}
		</template>

		<template v-else>
			<div class="row">
				<template v-for='item in items'>
					<div class="cols m_24 m__12 l_8 l___6 blockSol">
					<div class="conentBlock">
						<div class="image li">
							<a :href="item.button_right_link">
								<img :src="item.img || `${window.YAMASTERS_FRONTEND.templatePath}img/blockSolution.jpg`" alt="">
							</a>
						</div>

						<div class="textContainer">
							<div class="wr">
								<div class="name ">
									<p><a :href="item.header_link">{{item.header}}</a></p>
									<p v-if='item.cost' class="cost" v-html='item.cost'></p>
									<p v-if='item.lowcost' class="lowCost" v-html='item.lowcost'></p>
								</div>

								<div v-if='item.text' class="text">
								<p>{{item.text}}</p>
							</div>
							</div>
						</div>

						<div class="topButton li">
							<a v-if="item.top_button" :href="item.top_button_link">{{item.top_button}}</a>
						</div>

						<div class="botomButton li">
							<a v-if="item.botom_button" target="_blank" :href="item.botom_button_link" class="buttonLeft">
								{{item.botom_button}}
							</a>
							<a :href="item.button_right_link" class="buttonRight">
								{{item.button_right}}
							</a>
						</div>
					</div>
				</div>
				</template>
			</div>
		</template>

	</div>
</template>

<script>
module.exports = {
	props: ['data', 'merge', 'locked'],

	data() {
		return {
			items: [],
			templatePath: window.YAMASTERS_FRONTEND.templatePath,
			vw: window.innerWidth,
			window: window
		}
	},

	methods: {
		bx24_buy(item) {
			return {
				button_1: item.button
			}
		}
	},

	watch: {
		data() {
			// this.items = ;
			if(this.merge) {
				this.data.items.forEach(item => this.items.push(item));
			}
			else {
				this.items = this.data.items;
				// $('html, body').stop().animate({
				// 	scrollTop: $(this.$el).offset().top - 100
				// });
			}
		}
	},

	mounted() {
		window.addEventListener('resize', () => {
			this.vw = window.innerWidth;
		})
	},
}
</script>

<style lang="scss">
@import "scss/wanted";

#catalog-list{
	.conentBlock{
	box-shadow: 0px 16px 30px 10px rgba(0, 0, 0, 0.1);
	border-radius: 5px;
	padding-bottom: 1px;
	z-index: -1;
	max-width: 375px;
	margin: 0 auto;
	margin-bottom: 30px;
	.li{
		margin-bottom: 30px;
		padding: 0px 30px;
		border-radius: 5px 5px 0 0 ;
	}
	.li:nth-child(1){
		padding: 0px;
		img{
			width: 100%;
			visibility: visible;
			border-radius: 5px 5px 0px 0px;
		}
	}
	.image{
		height: 220px;
		overflow: hidden;
		position: relative;
		&:after{
			pointer-events: none;
		}
		img{
			width: 100%;
			height: auto;
			position: absolute;
			// @include vam;
			left: 0px;
			right: 0px;
			top: 0px;
			margin: 0 auto;
			max-height: none;
		}
	}
	.textContainer{
		position: relative;
		margin-bottom: 30px;
		.wr{
			padding: 0 30px;
			@include m_up{
				height: rem(145);
				overflow-y: hidden;
			};
		}
	}
	.name {
		font-size: rem(18);
		line-height: 27px;
		// height: 100%;
		width: 100%;
		display: flex;
		/*align-items: center;*/
		justify-content: space-between;
		z-index: 3;
		// position: relative;
		width: calc(100% + 10px);
		margin-bottom: rem(20);
		@include s_only{
			flex-direction: column;
		}
		@include m_up{
			height: 55px;
			overflow: hidden;
		}
		a{
			font-family: 'Conv_CirceBold';
			text-decoration: none;
			color: black;
		}
		p:nth-child(1){
			width: 100%;
			padding-right: 80px;
			@include m__only{
				padding-right: 70px;
				display: block;
			}
			@include s__only{
				padding-right: 0px;
			}
		}
		.cost{
			color: white;
			font-family: 'Conv_Circe';
			font-size: rem(16);
			min-width: 80px;
			// min-height: 60px;
			padding: 7px 11px;
			text-align: center;
			position: absolute;
			background-repeat: no-repeat;
			// background-image: url('#{$imgPathComponent}cost.png');
			background-size: contain;
			background-position: center 34%;
			background: #de4b39;
			right: -8px;
			top: 0;
			border-radius: 3px 0 0 3px;
			@include s_only{
				top: -50px;
			}
			i{
				font-style: normal;
			}
			b{
				font-weight: normal;
			}
			&:after{
				content: '';
				position: absolute;
				right: 0;
				bottom: -7px;
				width: 0;
				height: 0;
				border-style: solid;
				border-width: 7px 7px 0 0;
				border-color: #b13a2a transparent transparent transparent;
			}
		}
		.lowCost{
			font-family: 'Conv_Circe';
			font-size: rem(16);
			min-width: 80px;
			// min-height: 60px;
			padding: 7px 11px;
			text-align: center;
			position: absolute;
			background-repeat: no-repeat;
			// background-image: url('#{$imgPathComponent}cost.png');
			background-size: contain;
			background-position: center 34%;
			background: #e3de4c;
			color: #4b4d3b;
			right: -8px;
			top: -50px;
			border-radius: 3px 0 0 3px;
			@include s_only{
				top: -100px;
			}
			i{
				font-style: normal;
			}
			b{
				font-weight: normal;
			}
			&:after{
				content: '';
				position: absolute;
				right: 0;
				bottom: -7px;
				width: 0;
				height: 0;
				border-style: solid;
				border-width: 7px 7px 0 0;
				border-color: #cec824 transparent transparent transparent;
			}
		}
	}
	.text {
		font-size: rem(15);
		line-height: rem(22);
		@include m_up{
			max-height: rem(88);
			overflow: hidden;
		};
	}
	.topButton{
		min-height: 24px;
		padding-top: 2px;
		padding-bottom: 3px;
		&:after{
			display: none!important;
		}
		a{
			padding: 6px 10px 4px 10px;
			border: solid 1px black;
			opacity: 0.4;
			text-decoration: none;
			color: black;
			border-radius: 20px;
			font-size: rem(10);
			text-transform: uppercase;
			vertical-align: middle;
		}
	}
	.botomButton{
		@include clearfix;
		font-size: rem(18);
		line-height: rem(30);
		@include s_only {
			flex-direction: column;
			display: flex;
		}
		&:after{
			display: none!important;
		}
		a{
			display: inline-block;
			padding: 16px 30px 14px 30px;
			border-radius: 50px;
			text-decoration: none;
			color: #4b4d3b;
			text-align: center;
		}

		a.buttonLeft {
			float: left;
			background: #e3de4c;
			color: #4b4d3b;
			padding: 16px 40px 14px 40px;
			@include  transition(all,150ms,ease,0ms)
			@include m__only {
				padding: 14px 35px 12px 35px;
			}
			@include s_only {
				padding: 14px 25px 12px 25px;
				margin-bottom: 10px;
			}
			&:hover, &:active{
				background: #cec824;
			}
		}
		a.buttonRight {
			float: right;
			border: 1px #de4b39 solid;
			color: #de4b39;
			margin-left: 10px;
			@include  transition(all,150ms,ease,0ms)
			&:hover, &:active{
				background: #de4b39;
				color: white;
			}
			@include m__only {
				padding: 14px 25px 12px 25px;
			}
			@include s_only {
				padding: 14px 25px 12px 25px;
				margin: 0px;
			}
		}
	}
}
}
</style>



// WEBPACK FOOTER //
// catalog.vue?0b2cdee0